/* React core */
import { Component } from "react"
/* Redux binding */
import { connect } from "react-redux"

/* Router and shared utilities */
import { withRouter, utils } from "../helpers"
/* Page layout wrapper */
import Block from "./Block"
/* Icon component */
import Icon from "./Icon"
/* Auth API */
import { logout } from "../api/Auth"
/* Localization */
import { translate } from "../translates"

const ROUTES = {
    bookings: "/bookings", reviews: "/reviews", gifts: "/gifts",
    favorites: "/favourites", profile: "/profile", notifications: "/notifications", help: "/help"
}

const TITLES = {
    bookings: "Мои записи", reviews: "Мои отзывы", gifts: "Сертификаты",
    favorites: "Избранное", profile: "Профиль", notifications: "Уведомления", help: "Помощь"
}

const ITEMS = [
    { id: "bookings", label: "Мои записи", icon: "calendar" },
    { id: "reviews", label: "Мои отзывы", icon: "chat" },
    { id: "gifts", label: "Сертификаты", icon: "tag" },
    { id: "favorites", label: "Избранное", icon: "heart" },
    { id: "profile", label: "Профиль", icon: "user" }
]

/* Component Account */
class Account extends Component {

    constructor(props) {
        super(props)
        /* State */
        this.state = { confirmOut: false }
    }

    componentDidMount = () => {
        this._guard()
    }

    componentDidUpdate = () => {
        this._guard()
    }

    /* Draw Is Desktop */
    _isDesktop = () => window.matchMedia("(min-width: 901px)").matches

    /* Draw Guard */
    _guard = () => {
        if (!this.props.token) {
            this.props.toggleAuth(true)
            this.props.navigate("/")
            return
        }
        if (this.props.hub && this._isDesktop()) {
            this.props.navigate("/profile")
        }
    }

    /* Draw Logout */
    _logout = () => {
        if (this.props.token) {
            logout(this.props.token)
        }
        this.props.removeToken()
        this.props.removeUser()
        this.props.clearFavourites()
        this.props.navigate("/")
    }

    /* Draw Sidebar */
    _sidebar = () => {
        const user = this.props.user || { name: translate("Гость"), phone: "", avatar: "" }
        const active = this.props.active
        return (
            <aside className="sidebar">
                <div className="sidebar__user">
                    <span className="avatar"><img src={user.avatar || utils.FALLBACK_AVATAR} alt="" onError={utils.onAvatarError} /></span>
                    <div>
                        <div className="sidebar__user-name">{user.name}</div>
                        <div className="sidebar__user-phone">{user.phone}</div>
                    </div>
                </div>
                <div className="sidebar__group">
                    <div className="sidebar__label">{translate("Общее")}</div>
                    {ITEMS.map((item) => (
                        <button key={item.id} className={`sidebar__item ${active === item.id ? "is-active" : ""}`} onClick={() => this.props.navigate(ROUTES[item.id])}>
                            <Icon name={item.icon} size={18} />
                            <span>{translate(item.label)}</span>
                            <Icon name="chevron_right" size={14} className="sidebar__item-chev" />
                        </button>
                    ))}
                </div>
                <div className="sidebar__group">
                    <div className="sidebar__label">{translate("Дополнительно")}</div>
                    <button className={`sidebar__item ${active === "help" ? "is-active" : ""}`} onClick={() => this.props.navigate("/help")}>
                        <Icon name="headphones" size={18} />
                        <span>{translate("Помощь и поддержка")}</span>
                        <Icon name="chevron_right" size={14} className="sidebar__item-chev" />
                    </button>
                    {this.props.user && (
                        <button className="sidebar__item sidebar__item--danger" onClick={() => this.setState({ confirmOut: true })}>
                            <Icon name="user" size={18} />
                            <span>{translate("Выйти из аккаунта")}</span>
                        </button>
                    )}
                </div>
            </aside>
        )
    }

    /* Draw Topbar */
    _topbar = (title, back) => {
        return (
            <div className="account-topbar">
                <button className="account-topbar__back" onClick={() => this.props.navigate(back)} aria-label={translate("Назад")}><Icon name="chevron_left" size={22} /></button>
                <span className="account-topbar__title">{translate(title)}</span>
            </div>
        )
    }

    /* Draw Logout Modal */
    _logoutModal = () => {
        if (!this.state.confirmOut) {
            return null
        }
        return (
            <div className="modal-backdrop" onClick={() => this.setState({ confirmOut: false })}>
                <div className="modal modal--sm" onClick={(e) => e.stopPropagation()}>
                    <div className="confirm">
                        <div className="confirm__icon"><Icon name="user" size={26} /></div>
                        <h3 className="confirm__title">{translate("Выйти из аккаунта?")}</h3>
                        <p className="confirm__text">{translate("Вы выйдете из профиля на этом устройстве. Чтобы войти снова, понадобится номер телефона.")}</p>
                        <div className="confirm__actions">
                            <button className="btn btn--ghost" onClick={() => this.setState({ confirmOut: false })}>{translate("Отмена")}</button>
                            <button className="btn btn--danger" onClick={() => { this.setState({ confirmOut: false }); this._logout() }}>{translate("Выйти")}</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    /* Draw Hub */
    _hub = () => {
        const user = this.props.user || { name: translate("Гость"), phone: "", avatar: "" }
        const lang = this.props.lang
        return (
            <Block pageClass="app--no-footer">
                <div className="page">
                    <div className="container">
                        <div className="hub">
                            <div className="hub__user">
                                <span className="avatar"><img src={user.avatar || utils.FALLBACK_AVATAR} alt="" onError={utils.onAvatarError} /></span>
                                <div className="hub__name">{user.name}</div>
                                <div className="hub__phone">{user.phone}</div>
                            </div>
                            <div className="hub__menu">
                                {ITEMS.map((item) => (
                                    <button key={item.id} className="hub__item" onClick={() => this.props.navigate(ROUTES[item.id])}>
                                        <Icon name={item.icon} size={20} />
                                        <span>{translate(item.label)}</span>
                                        <Icon name="chevron_right" size={16} className="hub__chev" />
                                    </button>
                                ))}
                                <button className="hub__item" onClick={() => this.props.navigate("/help")}>
                                    <Icon name="headphones" size={20} />
                                    <span>{translate("Помощь и поддержка")}</span>
                                    <Icon name="chevron_right" size={16} className="hub__chev" />
                                </button>
                                <button className="hub__item hub__item--danger" onClick={() => this.setState({ confirmOut: true })}>
                                    <Icon name="user" size={20} />
                                    <span>{translate("Выйти из аккаунта")}</span>
                                </button>
                            </div>
                            <div className="hub__lang">
                                <span className="hub__lang-label">{translate("Язык")}</span>
                                <div className="hub__lang-switch">
                                    <button className={lang === "ru" ? "is-active" : ""} onClick={() => this.props.setLang("ru")}>RU</button>
                                    <button className={lang === "kk" ? "is-active" : ""} onClick={() => this.props.setLang("kk")}>KZ</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this._logoutModal()}
            </Block>
        )
    }

    render = () => {
        /* Don't flash the profile to guests — the guard redirects them home */
        if (!this.props.token) {
            return null
        }

        /* Hub is mobile-only; on desktop the guard redirects to /profile */
        if (this.props.hub) {
            if (this._isDesktop()) {
                return null
            }
            return this._hub()
        }

        const active = this.props.active
        const title = TITLES[active] || "Профиль"

        return (
            <Block pageClass="app--account">
                <div className="page">
                    <div className="container">
                        {this._topbar(title, "/account")}
                        <div className="profile">
                            {this._sidebar()}
                            <div>{this.props.children}</div>
                        </div>
                    </div>
                </div>
                {this._logoutModal()}
            </Block>
        )
    }
}

/* Map State To Props */
const mapStateToProps = state => {
    return {
        token: state.token,
        user: state.user,
        lang: state.lang
    }
}

/* Map Dispatch To Props */
const mapDispatchToProps = dispatch => {
    return {
        toggleAuth: data => dispatch({ type: "TOGGLE_AUTH", payload: data }),
        removeToken: () => dispatch({ type: "REMOVE_TOKEN" }),
        removeUser: () => dispatch({ type: "REMOVE_USER" }),
        clearFavourites: () => dispatch({ type: "CLEAR_FAVOURITE" }),
        setLang: data => dispatch({ type: "SET_LANG", payload: data })
    }
}

/* Export */
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Account))
